import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ContainerComponent } from '../../layout/container/container.component';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-whatsapp-section',
  standalone: true,
  imports: [CommonModule, RouterModule, ContainerComponent],
  templateUrl: './whatsapp-section.component.html',
  styleUrl: './whatsapp-section.component.scss'
})
export class WhatsappSectionComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('sectionElement', { static: false }) sectionElement?: ElementRef;
  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    // Track FAQ banner view when component loads
    setTimeout(() => this.trackFaqBannerView(), 100);
  }

  ngAfterViewInit() {
    // Registrar la sección para tracking de analytics
    if (this.sectionElement?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.sectionElement.nativeElement,
        'WhatsApp Section',
        'whatsapp-section-section'
      );
    }
  }

  ngOnDestroy() {
    // Unregister section from analytics tracking
    if (this.sectionElement?.nativeElement) {
      this.analyticsService.unregisterSectionFromTracking(this.sectionElement.nativeElement);
    }
  }

  // Método para manejar el click en el banner de FAQ
  onFaqBannerClick(): void {
    console.log('🖱️ WhatsApp Section: Clic en banner de FAQ');

    // Track FAQ banner click event
    this.trackFaqBannerClick();
  }

  // Método para rastrear el click en el banner de FAQ
  private trackFaqBannerClick(): void {
    const eventData = this.analyticsService.createPromotionEventData(
      0, // ID del banner (0 para banner principal)
      this.getCurrentDeviceType(),
      'WhatsApp Section FAQ Banner - Preguntas Frecuentes',
      'assets/Mask group.png',
      'whatsapp_section_faq_banner'
    );

    this.analyticsService.trackPromotionSelection(eventData);
  }

  // Método para rastrear cuando se muestra el banner de FAQ (view) - solo si es visible
  private trackFaqBannerView(): void {
    if (!this.sectionElement?.nativeElement) return;

    const eventData = this.analyticsService.createPromotionEventData(
      0, // ID del banner (0 para banner principal)
      this.getCurrentDeviceType(),
      'WhatsApp Section FAQ Banner - Preguntas Frecuentes',
      'assets/Mask group.png',
      'whatsapp_section_faq_banner'
    );

    this.analyticsService.trackPromotionViewIfVisible(eventData, this.sectionElement.nativeElement);
  }

  // Método para detectar el tipo de dispositivo
  private getCurrentDeviceType(): 'xl' | 'desktop' | 'tablet' | 'movil' {
    const width = window.innerWidth;
    if (width >= 1200) return 'xl';
    if (width >= 1024) return 'desktop';
    if (width >= 768) return 'tablet';
    return 'movil';
  }
}
